import { queryKeys } from "../queryKeys";
import { getPlaidLinkToken } from "../rest/plaid";
import useRequest, { type QueryOptions } from "./useRequest";

export type PlaidLinkToken = { expiration: string; link_token: string };

export const useGetPlaidLinkToken = ({
  accountID,
  options,
}: {
  accountID: string;
  options?: QueryOptions<PlaidLinkToken>;
}) =>
  useRequest<PlaidLinkToken>(
    queryKeys.funding.plaidToken(accountID),
    () => getPlaidLinkToken(accountID),
    {
      ...options,
      enabled: !!accountID && (options?.enabled ?? true),
    },
  );
